/*
===============================================================================
VLETTE COMPLEMENTARY PAIR JS
Shared responsive overlay for V·lette collection-card matching product links.

- Mobile: bottom sheet.
- Desktop: centred dialog, controlled by CSS.
===============================================================================
*/

(function () {
  'use strict';

  if (window.__vletteComplementaryPairInit) return;
  window.__vletteComplementaryPairInit = true;

  var activeSheet = null;
  var activeTrigger = null;
  var lastFocusedElement = null;
  var closeTimer = null;

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function haltPairEvent(event) {
    if (!event) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function getSheetFromTrigger(trigger) {
    if (!trigger) return document.querySelector('[data-vlette-complementary-pair-sheet]');

    var sheetId = trigger.getAttribute('data-vlette-complementary-pair-sheet-id') || trigger.getAttribute('aria-controls');

    if (sheetId) {
      var controlledSheet = document.getElementById(sheetId);
      if (controlledSheet && controlledSheet.matches('[data-vlette-complementary-pair-sheet]')) {
        return controlledSheet;
      }
    }

    var localSection = closest(trigger, '[data-vlette-summary-section], [data-vlette-summary-stack], [data-vlette-style-catalogue], section');
    if (localSection) {
      var localParent = localSection.parentElement;
      var localSheet = localParent ? localParent.querySelector('[data-vlette-complementary-pair-sheet]') : null;
      if (localSheet) return localSheet;
    }

    return document.querySelector('[data-vlette-complementary-pair-sheet]');
  }

  function getPanel(sheet) {
    return sheet ? sheet.querySelector('.vlette-complementary-pair-sheet__panel') : null;
  }

  function getOpenSheet() {
    return document.querySelector('[data-vlette-complementary-pair-sheet].is-visible');
  }

  function parsePairData(card) {
    if (!card) return null;

    var script = card.querySelector('[data-vlette-complementary-pair-data]');
    if (!script) return null;

    try {
      var pairData = JSON.parse(script.textContent || script.innerHTML || '{}');
      var activeSwatch = card.querySelector('[data-vlette-summary-colour-swatch].is-active, [data-vlette-summary-colour-swatch][aria-pressed="true"]');

      if (activeSwatch && pairData) {
        pairData.selectedColourHandle = activeSwatch.getAttribute('data-vlette-colour-handle') || pairData.selectedColourHandle || '';
        pairData.selectedColour = activeSwatch.getAttribute('data-vlette-colour-name') || pairData.selectedColour || '';
      }

      return pairData;
    } catch (error) {
      return null;
    }
  }

  function setText(sheet, selector, value) {
    var node = sheet ? sheet.querySelector(selector) : null;
    if (!node) return;

    value = value || '';
    node.textContent = value;
    node.hidden = !value;
  }

  function clearNode(node) {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function makeElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }


  function viewLabelForTitle(title) {
    title = String(title || '').trim();
    return 'View ' + (title || 'matching product') + ' →';
  }

  function getProductDescriptor(item) {
    return String(item && item.mediumDescriptor ? item.mediumDescriptor : '').trim();
  }

  function appendProductDescriptor(parent, item) {
    var descriptor = getProductDescriptor(item);
    if (!descriptor || !parent) return;

    var descriptorNode = makeElement('p', 'vlette-complementary-pair-sheet__descriptor', descriptor);
    parent.appendChild(descriptorNode);
  }

  function getStandaloneEyebrows(sheet) {
    if (!sheet) return [];

    var eyebrows = sheet.querySelectorAll('.vlette-complementary-pair-sheet__eyebrow');
    return Array.prototype.filter.call(eyebrows, function (eyebrow) {
      return !closest(eyebrow, '.vlette-complementary-pair-sheet__product');
    });
  }

  function setStandaloneEyebrows(sheet, visible) {
    var eyebrows = getStandaloneEyebrows(sheet);

    for (var i = 0; i < eyebrows.length; i++) {
      eyebrows[i].hidden = !visible;
    }

    return eyebrows.length > 0;
  }


  function getSelectedColourHandle(pairData) {
    return pairData && pairData.selectedColourHandle ? String(pairData.selectedColourHandle) : '';
  }

  function getItemUrl(item, pairData) {
    var colourHandle = getSelectedColourHandle(pairData);

    if (item && colourHandle && item.urlsByColour && item.urlsByColour[colourHandle]) {
      return item.urlsByColour[colourHandle];
    }

    return item && item.url ? item.url : '#';
  }

  function getItemColourName(item, pairData) {
    var colourHandle = getSelectedColourHandle(pairData);

    if (item && colourHandle && item.colourNamesByHandle && item.colourNamesByHandle[colourHandle]) {
      return item.colourNamesByHandle[colourHandle];
    }

    return item && item.matchedColour ? item.matchedColour : (pairData && pairData.selectedColour ? pairData.selectedColour : '');
  }

  function getItemImages(item, pairData) {
    var colourHandle = getSelectedColourHandle(pairData);
    var imagesByColour = item && item.imagesByColour ? item.imagesByColour : null;
    var colourImages = imagesByColour && colourHandle && Array.isArray(imagesByColour[colourHandle]) ? imagesByColour[colourHandle] : [];
    var fallbackImages = item && Array.isArray(item.images) ? item.images : [];
    var images = colourImages.length ? colourImages : fallbackImages;

    return images.slice(0, 2).filter(function (image) { return image && image.src; });
  }

  function buildImageGrid(item, pairData) {
    var images = getItemImages(item, pairData);
    var grid = makeElement('div', 'vlette-complementary-pair-sheet__image-grid');

    if (!images.length) {
      grid.classList.add('vlette-complementary-pair-sheet__image-grid--empty');
      return grid;
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      var imageFrame = document.createElement('div');
      imageFrame.className = 'vlette-complementary-pair-sheet__image-frame';

      var img = document.createElement('img');
      img.className = 'vlette-complementary-pair-sheet__image';
      img.src = image.src;
      if (image.srcset) img.srcset = image.srcset;
      img.sizes = '(min-width: 769px) 190px, 45vw';
      img.alt = image.alt || item.title || '';
      img.loading = 'lazy';
      img.decoding = 'async';

      if (image.width) img.width = image.width;
      if (image.height) img.height = image.height;

      imageFrame.appendChild(img);
      grid.appendChild(imageFrame);
    }

    return grid;
  }

  function renderPairProducts(sheet, pairData, useStandaloneSingleEyebrow) {
    var list = sheet ? sheet.querySelector('[data-vlette-complementary-pair-products]') : null;
    if (!list) return;

    clearNode(list);

    var items = pairData && Array.isArray(pairData.items) ? pairData.items.filter(function (item) { return item && item.title; }) : [];
    if (!items.length) {
      var fallback = makeElement('p', 'vlette-complementary-pair-sheet__empty', 'No matching product is currently available.');
      list.appendChild(fallback);
      return;
    }

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var productTitle = item.title || item.shortTitle;
      var article = makeElement('article', 'vlette-complementary-pair-sheet__product');

      if (items.length > 1) {
        article.classList.add('vlette-complementary-pair-sheet__product--stacked');
      }

      if (items.length > 1 || !useStandaloneSingleEyebrow) {
        var eyebrowText = String(item.eyebrow || 'Make it a set').trim() || 'Make it a set';
        var eyebrow = makeElement('p', 'vlette-complementary-pair-sheet__eyebrow', eyebrowText);
        article.appendChild(eyebrow);
      }

      var heading = makeElement('h3', 'vlette-complementary-pair-sheet__product-heading', productTitle);
      article.appendChild(heading);
      appendProductDescriptor(article, item);

      article.appendChild(buildImageGrid(item, pairData));

      var cta = document.createElement('a');
      cta.className = 'vlette-complementary-pair-sheet__cta';
      cta.href = getItemUrl(item, pairData);
      cta.textContent = viewLabelForTitle(productTitle);
      article.appendChild(cta);

      list.appendChild(article);
    }
  }

  function updatePairContent(sheet, pairData) {
    if (!sheet || !pairData) return;

    var items = Array.isArray(pairData.items) ? pairData.items.filter(function (item) { return item && item.title; }) : [];
    sheet.classList.toggle('vlette-complementary-pair-sheet--single', items.length <= 1);
    sheet.classList.toggle('vlette-complementary-pair-sheet--multiple', items.length > 1);
    sheet.classList.toggle('vlette-complementary-pair-sheet--count-2', items.length === 2);
    sheet.classList.toggle('vlette-complementary-pair-sheet--count-3', items.length >= 3);
    sheet.style.setProperty('--vlette-pair-count', String(Math.max(1, Math.min(items.length, 3))));

    setText(sheet, '[data-vlette-complementary-pair-title]', '');
    setText(sheet, '[data-vlette-complementary-pair-descriptor]', '');
    setText(sheet, '[data-vlette-complementary-pair-lead]', '');

    var useStandaloneSingleEyebrow = items.length <= 1 && setStandaloneEyebrows(sheet, true);
    if (items.length > 1) {
      setStandaloneEyebrows(sheet, false);
    }

    renderPairProducts(sheet, pairData, useStandaloneSingleEyebrow);
  }

  function openPairSheet(pairData, trigger) {
    if (!pairData || !trigger) return;

    var sheet = getSheetFromTrigger(trigger);
    if (!sheet) return;

    var openSheet = getOpenSheet();
    if (openSheet && openSheet !== sheet) {
      closePairSheet(openSheet, false, true);
    }

    window.clearTimeout(closeTimer);

    activeSheet = sheet;
    activeTrigger = trigger;
    lastFocusedElement = document.activeElement || trigger || null;
    activeTrigger.setAttribute('aria-expanded', 'true');

    updatePairContent(sheet, pairData);

    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vlette-complementary-pair-is-open');

    window.requestAnimationFrame(function () {
      sheet.classList.add('is-visible');

      var panel = getPanel(sheet);
      if (panel) panel.focus({ preventScroll: true });
    });
  }

  function closePairSheet(sheet, restoreFocus, immediate) {
    sheet = sheet || activeSheet || getOpenSheet();
    if (!sheet || sheet.hidden) return;

    if (restoreFocus !== false) restoreFocus = true;

    window.clearTimeout(closeTimer);

    sheet.classList.remove('is-visible');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vlette-complementary-pair-is-open');

    var finishClose = function () {
      sheet.hidden = true;

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
      }

      if (restoreFocus) {
        if (activeTrigger && document.body.contains(activeTrigger)) {
          activeTrigger.focus({ preventScroll: true });
        } else if (lastFocusedElement && document.body.contains(lastFocusedElement)) {
          lastFocusedElement.focus({ preventScroll: true });
        }
      }

      if (sheet === activeSheet) {
        activeSheet = null;
        activeTrigger = null;
        lastFocusedElement = null;
      }
    };

    if (immediate) {
      finishClose();
    } else {
      closeTimer = window.setTimeout(finishClose, 260);
    }
  }

  function trapFocus(event) {
    if (!activeSheet || activeSheet.hidden || event.key !== 'Tab') return;

    var panel = getPanel(activeSheet);
    if (!panel) return;

    var focusable = panel.querySelectorAll('a[href]:not([hidden]), button:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])');
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = closest(target, '[data-vlette-complementary-pair-trigger]');

    if (trigger) {
      haltPairEvent(event);

      var card = closest(trigger, '[data-vlette-card]');
      var pairData = parsePairData(card);
      if (!pairData) return false;

      openPairSheet(pairData, trigger);
      return false;
    }

    var close = closest(target, '[data-vlette-complementary-pair-close]');
    if (close) {
      haltPairEvent(event);
      closePairSheet(closest(close, '[data-vlette-complementary-pair-sheet]'), true, false);
      return false;
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePairSheet(null, true, false);
      return;
    }

    trapFocus(event);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (activeSheet && event.target && event.target.contains(activeSheet)) {
      closePairSheet(activeSheet, false, true);
    }
  });
})();
